import React from "react";
import "../../css/lp-hero.css";
import ExamList from "../ExamList";
import { ReactComponent as LineCurl1 } from "../../assets/icons/hero/curl-line-one.svg";
import { ReactComponent as GreenLine } from "../../assets/icons/hero/hero-green-line.svg";
import { ReactComponent as LineCurl2 } from "../../assets/icons/hero/curl-line-two.svg";
import LgHeroImage from "../../assets/images/student-lg.png";
import MbHeroImage from "../../assets/images/student-mb.png";

const Hero = () => {
  return (
    <section id="hero">
      <div>
        <div>
          <article>
            <LineCurl1 id="curl-one" />
            <h1>
              <span>Prepare for exams, </span>
              <span>the convenient and </span>
              <span>efficient way</span>
              <GreenLine id="green-line" />
            </h1>
            <p>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pharetra,
              mi enim et auctor sapien cras cum rutrum.
            </p>
            <div>
              <span id="join-students">
                Join other students preparing well for
              </span>
              <div id="exam-list-cont">
                <ExamList />
              </div>
            </div>
          </article>
          <div id="hero-images">
            <img id="hero-img-lg" src={LgHeroImage} alt="a happy student" />
            <img id="hero-img-mb" src={MbHeroImage} alt="a happy student" />
            <div id="mb-overlay"></div>
            <LineCurl2 id="curl-two" />
          </div>
        </div>
        <div className="hero-buttons">
          <button>Get started</button>
          <button>Explore courses</button>
        </div>
      </div>
    </section>
  );
};

export default Hero;
